import { render, staticRenderFns } from "./reciepeDetails.vue?vue&type=template&id=4d5d4ba1&"
import script from "./reciepeDetails.vue?vue&type=script&lang=js&"
export * from "./reciepeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports